import {Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {Keyboard} from '@capacitor/keyboard';
import {IonInput} from '@ionic/angular';
import {AssistantActionsEnum} from '../../../Shared/Enum/assistant-actions.enum';

@Component({
  selector: 'app-assistant-input',
  templateUrl: './assistant-input.component.html',
  styleUrls: ['./assistant-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AssistantInputComponent {

  @ViewChild(IonInput, {static: false}) input!: IonInput;

  @Input() action: string = AssistantActionsEnum.waiting;
  @Input() placeholder: string = 'COMPONENTS.ASSISTANT_INPUT.PLACEHOLDER';

  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>;

  @Output() clickSendPrompt: EventEmitter<void> = new EventEmitter<void>;

  readonly assistantActionEnum = AssistantActionsEnum;


  /**
   * Enviar mensaje
   *
   */
  sendPrompt() {

    if (this.action !== this.assistantActionEnum.waiting) {
      return;
    }

    if (Capacitor.isNativePlatform()) {
      setTimeout(() => Keyboard.hide(), 100);
    }

    this.clickSendPrompt.emit()
  }

}
